<!-- Texty k vrstvě -->
<template>
  <div>
    <hr />
    <h4>Komentáře</h4>

    <div
      class="singleComment singleComment--reply"
      v-for="c in comments"
      :key="`comment-${c.id}`"
    >
      <div class="singleComment__header">
        <div>
          {{ c.author.firstName }}
          {{ c.author.lastName }}
        </div>
        <div>
          {{ getFullDate(c.date.date) }}
        </div>
      </div>
      <div class="singleComment__content">{{ c.text }}</div>
    </div>

    <form @submit="sendForm" method="post">
      <textarea placeholder="Váš komentář" v-model="newComment_text"></textarea>
      <input type="submit" value="Přidat komentář" class="btn btn--secondary" />
    </form>
  </div>
</template>

<script>
import CommentService from '@/services/CommentService';
import { getFullDate } from '@/utils/date';

export default {
  props: {
    layer: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      comments: [],
      commentsLoaded: false,

      newComment_text: ''
    };
  },
  components: {},
  mounted: function () {
    this.loadComments();
    if (this.layer.isActive) {
      console.log(this.layer);
    }
  },
  methods: {
    loadComments() {
      CommentService.getComments(this.layer.id)
        .then((result) => {
          if (result.data) {
            this.$emit('comments-loaded', {
              id: this.layer.id,
              count: result.data.length
            });
            this.commentsLoaded = true;
            if (result.data.length > 0) {
              this.comments = result.data;
            }
          }
        })
        .catch(() => {});
    },
    getFullDate(dateTime) {
      return getFullDate(dateTime);
    },
    sendForm(e) {
      e.preventDefault();

      const data = {
        text: this.newComment_text
      };

      CommentService.addComment(this.layer.id, data)
        .then((response) => {
          this.comments.push(response.data.data);

          this.newComment_text = '';
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.singleComment__content {
  white-space: pre-line;
}
</style>
